import axios from "axios";
import router from "../../router";

const state = {
  settings: [],
};

const getters = {
  settings(state) { return state.settings },
  settings_sd_switch(state) {
    if (state.settings.length) {
      return parseInt(state.settings.find(setting => setting.setting === 'sudden_death_on').value);
    }
  }
};

const actions = {
  getSettings({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + 'settings')
    .then(response => {
      const sdSwitch = parseInt(response.data.data.settings.find(setting => setting.setting === 'sudden_death_on').value);
      if (router.currentRoute.path === '/sudden-death' && sdSwitch != 1) {
        router.push('/');
      }
      commit('SET_SETTINGS', response.data.data.settings);
    })
  },
};

const mutations = {
  SET_SETTINGS(state, data) { state.settings = data },
};


export default {
  state,
  getters,
  actions,
  mutations,
}
